export default "__VITE_ASSET__C6_0xIFm__"